import { eventBus } from '@/eventBus';

export default {
  data: () => ({
    isSubmitting: false
  }),
  mounted () {
    eventBus.$on('isSubmitting', this.handleIsSubmitting);
  },
  beforeUnmount () {
    eventBus.$off('isSubmitting', this.handleIsSubmitting);
  },
  methods: {
    handleIsSubmitting (value) {
      this.isSubmitting = value;
    }
  }
};
